import { DependenciesInjection } from "app/di/DependencyInjection";
import { BalanceHistoryImpl } from "features/balanceHistory/data/BalanceHistoryImpl";
import { BalanceHistoryViewModel } from "features/balanceHistory/presentation/viewModel/BalanceHistoryViewModel";
import { BalanceHistoryToken } from "./BalanceHistoryToken";
import { IBalanceHistoryRepository } from "../domain/repositories/IBalanceHistoryRepository";
import { BalanceHistoryUseCase } from "../domain/useCases/BalanceHistoryUseCase";

export class BalanceHistoryInjection {
  static injectBalanceHistory() {
    DependenciesInjection.register<IBalanceHistoryRepository>(
      BalanceHistoryToken.IBalanceHistoryRepository,
      BalanceHistoryImpl,
      "otherRepo",
    );
    DependenciesInjection.register<BalanceHistoryUseCase>(
      BalanceHistoryToken.BalanceHistoryUseCase,
      BalanceHistoryUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<BalanceHistoryViewModel>(
      BalanceHistoryToken.BalanceHistoryViewModel,
      BalanceHistoryViewModel,
      "viewModel",
    );
  }

  static getBalanceHistoryRepo() {
    return DependenciesInjection.getRepo<IBalanceHistoryRepository>(
      BalanceHistoryToken.IBalanceHistoryRepository,
    );
  }

  static getBalanceHistoryUseCase() {
    return DependenciesInjection.getRepo<BalanceHistoryUseCase>(
      BalanceHistoryToken.BalanceHistoryUseCase,
    );
  }
}
